'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const tryGet=require('pulsar-utils/dist-es6/extensions/tryGet');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const fpe=require('../../../../dist-es6/shared/extensions/fatiguePointExtensions');let

ScheduleGraphDirective=function(_BaseControllerBacked){_inherits(ScheduleGraphDirective,_BaseControllerBacked);function ScheduleGraphDirective(){_classCallCheck(this,ScheduleGraphDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(ScheduleGraphDirective,[{key:'templateUrl',get:function()
{
return'/templates/directives/scheduleGraphDirective/scheduleGraphTemplate';
}},{key:'objectBindings',get:function()

{
return[
'interval',
'duties',
'trips',
'sleep',
'sleepPromotingIntervals',
'fatigue',
'incidents',
'now',
'timeOfLastScheduleUpdate',
'invalidDataWarning',
'predictedWorkday',
'forecastDutyInterval',
'fatigueThreshold',
'dutyLabelFormatter',
'tripLabelFormatter',
'sleepLabelFormatter',
'sleepPromotingLabelFormatter',
'selectedInterval'];

}},{key:'textBindings',get:function()

{
return[
'useReportStyle'];

}},{key:'controller',get:function()

{
return ScheduleGraphDirectiveController;
}}]);return ScheduleGraphDirective}(BaseControllerBackedDirective);let


ScheduleGraphDirectiveController=function(){_createClass(ScheduleGraphDirectiveController,null,[{key:'$inject',get:function()
{
return[];
}}]);
function ScheduleGraphDirectiveController(){var _this2=this;_classCallCheck(this,ScheduleGraphDirectiveController);
this.elementBindings={};

this.plotterVerticalMargin=this.useReportStyle?10:5;

const actualTripHeight=this.useReportStyle?13:32;
const actualSleepPromotingHeight=Math.round(actualTripHeight*0.375);
this.sleepVerticalMargin=this.plotterVerticalMargin+actualSleepPromotingHeight+1;

this.tripHeight=actualTripHeight+this.plotterVerticalMargin*2;
this.sleepPromotingHeight=actualSleepPromotingHeight+this.plotterVerticalMargin*2;

this.incidentPointRadius=this.useReportStyle?8:9.5;
this.sleepLabelFontStyle=this.useReportStyle?'normal 8px "Open Sans"':null;

this.fatigueStrokeWidth=this.useReportStyle?2:4;
this.fatigueAlertOffsetTop=this.useReportStyle?10:0;

this._alertRanges=fpe(this.fatigue).getAlertRangesOverlapping(this.fatigueThreshold,this.duties.concat(this.trips).concat(this.forecastDutyInterval?[this.forecastDutyInterval]:[]));

this.alertingForecastedDutyIntervals=_.exists(this.forecastDutyInterval)?
TimeInterval.compress(_.compact(this._alertRanges.At.concat(this._alertRanges.Above).map(function(i){return _this2.forecastDutyInterval.intersection(i)}))):
[];

const timeOfLastScheduleUpdate=_.exists(this.invalidDataWarning)?this.timeOfLastScheduleUpdate:void 0;
const now=!_.exists(this.invalidDataWarning)?
tryGet(this.timeOfLastScheduleUpdate).otherwise(this.now):
this.now;

if(_.exists(timeOfLastScheduleUpdate)&&this.interval.contains(timeOfLastScheduleUpdate)){
this._endOfScheduleMarker=[{time:timeOfLastScheduleUpdate,tooltipText:this.invalidDataWarning}];
}else{
this._endOfScheduleMarker=[];
}

if(this.interval.contains(now)){
this._nowMarker=[now];
}else{
this._nowMarker=[];
}

this._futureMaskStart=this.forecastDutyInterval?this.forecastDutyInterval.end:now;
}return ScheduleGraphDirectiveController}();


module.exports=ScheduleGraphDirective;
module.exports.DirectiveController=ScheduleGraphDirectiveController;
//# sourceMappingURL=scheduleGraphDirective.js.map
